<template>
  <div>
    <!-- Route List -->
    <div class="tabs is-centered is-medium">
      <ul>
        <li :class="{ 'is-active': true }">
          <a>Rute vozila</a>
        </li>
      </ul>
    </div>

    <!-- Vozilo -->
    <p>{{ vehicle.model }}</p>

    <!-- Tabela ruta -->
    <route-list-table :data="routeLogs"></route-list-table>
  </div>
</template>

<script>
import reportService from "../../services/report.service";
import RouteListTable from "./RouteListTable.vue";

export default {
  name: "RouteList",

  components: {
    RouteListTable,
  },

  props: {
    today: Date,
    tomorrow: Date,
    vehicle: Object,
  },

  watch: {
    vehicle: function (newVal, oldVal) {
      // watch it
      console.log("Prop changed: ", newVal, " | was: ", oldVal);

      this.resetUi();
      this.prepare();
    },
  },

  data() {
    return {
      routeLogs: [],
    };
  },

  mounted() {
    console.log("mounted");
    this.prepare();
  },

  methods: {
    async prepare() {
      this.routeLogs = [];

      this.routeLogs = (
        await reportService.GetRouteLogsByStartDateAndEndDateAndVehicleId(
          this.vehicle.vehicleId,
          this.today,
          this.tomorrow
        )
      ).data;
    },

    resetUi() {
      console.log("RESET");
    },
  },
};
</script>
